import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ofType } from "redux-observable";
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";
import Types from "../actions/types";
import { onListFailed, onListSuccess } from "../actions";
import * as fromOrganisations from "features/organisations";

const taskTypeListEffect = (action$, state$) =>
	action$.pipe(
		ofType(
			Types.TASK_TYPE_LIST_REQUESTED,
			Types.TASK_TYPE_CREATE_SUCCEEDED,
			Types.TASK_TYPE_UPDATE_SUCCEEDED,
			Types.TASK_TYPE_DELETE_SUCCEEDED,
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED
		),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => tokenExists()),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(() => {
			return ajax
				.get(
					`${getOrganisationBaseUrl(state$.value)}/organisation-task-type/all`,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onListSuccess(ajaxResponse.response))
					),
					catchError((error) => of(onListFailed(error)))
				);
		})
	);

export default taskTypeListEffect;
